import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LatestChapters from "./components/LatestChapters";
import SerialProgress from "./components/SerialProgress";
import StoryIntro from "./components/StoryIntro";
import Characters from "./components/Characters";
import FollowCTA from "./components/FollowCTA";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import Seo from "./components/Seo";

export default function Home() {
  return (
    <>
      <Seo />
      <Navbar />
      <main>
        <Hero />
        <LatestChapters />
        <SerialProgress />
        <StoryIntro />
        <Characters />
        <FollowCTA />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}